<template>
<ItpFormSelect2
  :name="fieldName"
  v-model="item[fieldName]"
  bind-object
  :options="projects"
  valueField="id"
  textField="name"
  :clearable="clearable"
  :readonly="item.isReadonly"
  @optionSelected="evh_7315092382398562_optionSelected($event, {})"
>
</ItpFormSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcProjectSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "project",
  })
  fieldName!: string;

  @Watch('fieldName')
  onField_name(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fieldName")
  }

  @Prop({
    type: Boolean,
    default: true,
  })
  clearable!: boolean;

  @Watch('clearable')
  onClearable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clearable")
  }

  projects!: any;

  async $$load_projects() {
    return this.$fn.fetch('list_project')
  }

  messages!: any;
  ux!: any;
  dataMembers = ['projects', 'messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        projects: null,
        messages: {
          searchPlaceholder: this.$fn.pgettext("Project", "Search for invoice"),
        }
        ,
        ux: null,
      },
    }
  }

  async act_7315092382398562_emit_8058_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_8058, alias=undefined
    return {
      event: "optionSelected",
      value: $event.option,
    }
  }

  async evh_7315092382398562_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_8058: actions.EmitAction;
    evh_7315092382398562_optionSelected_8057: actions.EventHandlerImpl;
    evh_7315092382398562_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_8058 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_8058_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_optionSelected_8057 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_8058,
        event: "optionSelected",
        displayName: "emit",
      }
    );
    const evh_7315092382398562_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_optionSelected_8057],
      }
    );
    return {
      act_7315092382398562_emit_8058,
      evh_7315092382398562_optionSelected_8057,
      evh_7315092382398562_optionSelected,
    }
  }
}

Vue.component("UcProjectSelector", UcProjectSelector);

</script>